import { OtoIndividualPlace } from '../../lib/types/models/journey-place/oto-individual-place'
import { OtoIndividualPlaceInput } from '../../lib/types/models/journey-place/oto-individual-place-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const createOtoIndividualPlace = async (
  input: OtoIndividualPlaceInput & { journeyPlaceId: number }
) => {
  const { journeyPlaceId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.journeyPlaces.createOtoIndividualPlace.url, { id: journeyPlaceId }))
    .post<OtoIndividualPlace, OtoIndividualPlaceInput>(data)
}
